import styled from 'styled-components';

export const StyledHr = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray07};
  width: 100%;
  margin: 0 0 0.25rem 0;
`;
